<template>
  <section class="view-lessons py-5">
    <div class="container py-5">
      <div class="row">
        <div class="col-lg">
          <h1>Todas as aulas</h1>
          <!-- <div class="subtitle">Novas aulas todos os sábados, às 21 horas.</div> -->
        </div>
        <div class="col-lg d-flex align-items-center justify-content-end">
          <chunk-selector
            :current="chunk"
            @select="selectChunk"
            v-if="!$route.params.tag"
          />
        </div>
      </div>

      <action-dispatcher
        v-if="$user.cof"
        action="courses/getLessons"
        ref="actionDispatcher"
        :parameters="{
          id: $user.cof.id,
          params: parameters
        }"
      >
        <div class="row">
          <div
            v-for="(lesson, index) in lessons"
            :key="index"
            class="col-lg-3 col-md-6 py-2"
          >
            <lesson-img :lesson="lesson" />
          </div>
        </div>
      </action-dispatcher>

      <pagination
        class="pt-5"
        :count="count"
        :page="page"
        :limit="parameters.limit"
        @paginate="paginate"
      />
    </div>
  </section>
</template>

<script>
import Pagination from "@/mixins/Pagination";
import ChunkSelector from "../components/lesson/ChunkSelector";
import { mapState } from "vuex";

export default {
  mixins: [Pagination],
  components: { ChunkSelector },
  data() {
    const chunk =
      this.$route.query.from !== undefined
        ? parseInt(this.$route.query.from) / 100 + 1
        : Math.ceil(this.$user.cof.count_lessons / 100);

    return {
      perPage: 20,
      chunk,
      extraParameters: {
        from: (chunk - 1) * 100,
        to: chunk * 100 + 1,
        tag: this.$route.params.tag
      }
    };
  },
  computed: {
    ...mapState("courses", ["lessons", "count"])
  },
  methods: {
    reload() {
      this.$refs.actionDispatcher.dispatch();
    },
    selectChunk(chunk) {
      this.chunk = chunk;
      this.extraParameters = {
        from: (chunk - 1) * 100,
        to: chunk * 100 + 1
      };
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...this.extraParameters
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-lessons {
  h1 {
    margin-bottom: 0;
  }

  .subtitle {
    font-size: 16px;
    line-height: 24px;
    color: #979797;
    margin-bottom: 52px;
  }
}
</style>
